import { getRequest } from "../../../services/RestServices";
import { GET_JOBS_Dropdown, GET_REVIEW_DETAILS } from "../../api/scheduler/url";

export const getDropDownData = async (so_Id) => {
  try {
    return await getRequest(`${GET_JOBS_Dropdown}/${so_Id}`);
  } catch (err) {
    return err;
  }
};

export const getReviewDetails = async (job_Id) => {
  try {
    return await getRequest(`${GET_REVIEW_DETAILS}/${job_Id}`);
  } catch (err) {
    return err;
  }
};
